import {
	mainUrl
} from '../../Constants';
import axios from 'axios';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const TOKEN_VALID = 'TOKEN_VALID';
export const TOKEN_INVALID = 'TOKEN_INVALID';
export const UPDATE_LOGIN = 'UPDATE_LOGIN';
export const REDIRECT_PATH_SET = 'REDIRECT_PATH_SET';

export function redirectPathSet(redirectPath) {
	return {
		type: REDIRECT_PATH_SET,
		redirectPath
	};
}
function requestLogin(creds) {
	return {
		type: LOGIN_REQUEST,
		isFetching: true,
		isAuthenticated: false,
		creds
	};
}
	
function receiveLogin(token, accountId, isAdmin, isSuperman, userId, accessCode, firstName, lastName, isEventCreator) {
	return {
		type: LOGIN_SUCCESS,
		isFetching: false,
		isAuthenticated: true,
		id_token: token,
		isAdmin,
		isSuperman,
		userId,
		accountId,
		accessCode,
		firstName,
		lastName,
		isEventCreator
	};
}

function loginError(message) {
	return {
		type: LOGIN_FAILURE,
		isFetching: false,
		isAuthenticated: false,
		message
	};
}

function requestLogout() {
	return {
		type: LOGOUT_REQUEST,
		isFetching: true,
		isAuthenticated: true
	};
}

function receiveLogout() {
	return {
		type: LOGOUT_SUCCESS,
		isFetching: false,
		isAuthenticated: false
	};
}

function tokenValid(token) {
	return {
		type: TOKEN_VALID,
		isAuthenticated: true,
		id_token: token
	};
}

export function tokenInvalid() {
	return {
		type: TOKEN_INVALID,
		isAuthenticated: false
	};
}


function updateLogin(userId, isAdmin, isSuperman,  accountId, accessCode, firstName, lastName, isEventCreator) {
	return {
		type: UPDATE_LOGIN,
		userId,
		isAdmin,
		isSuperman,
		accountId,
		accessCode,
		firstName,
		lastName,
		isEventCreator

	};
}
export function loginUser(creds) {

	return dispatch => {
		// We dispatch requestLogin to kickoff the call to the API
		dispatch(requestLogin(creds));

		return axios.post(mainUrl + 'auth/token', { UserName: creds.username, Password: creds.password })

			.then((

				response
			) => {
				if (response.status !== 200) {
					// If there was a problem, we want to
					// dispatch the error condition
					dispatch(loginError(response.err));
				} else {
								
					// If login was successful, set the token in local storage
					localStorage.setItem('id_token', response.data.token);
					localStorage.setItem('accountId', response.data.accountId);
					localStorage.setItem('userId', response.data.id);
					localStorage.setItem('isAdmin', "" + response.data.isAdmin);
					localStorage.setItem('isSuperman', "" +   response.data.isSuperman);
					localStorage.setItem('isEventCreator', "" + (response.data.isEventCreator || false));
					localStorage.setItem('accessCode', response.data.accessCode);
					localStorage.setItem('userFirstName', response.data.firstName);
					localStorage.setItem('userLastName', response.data.lastName);
					// eslint-disable-next-line no-console
					
					// Dispatch the success action
					dispatch(receiveLogin(response.data.token, response.data.accountId,  response.data.isAdmin, response.data.isSuperman, response.data.id, response.data.accessCode,  response.data.userFirstName, response.data.userLastName, response.data.isEventCreator || false));
				}
			}).catch(err => {
				if (err.response) {
					dispatch(loginError(err.response.data));

				} else {
					dispatch(loginError("Network Error"));
				}
			});
	};
}

// login UTK CAS user
export function loginUTKUser() {

	return dispatch => {
		// We dispatch requestLogin to kickoff the call to the API
		// dispatch(requestLogin(creds))
		return axios.get(mainUrl + 'auth/SingleSignOn')

			.then((

				response
			) => {
				if (response.status !== 200) {
					// If there was a problem, we want to
					// dispatch the error condition
					dispatch(loginError(response.err));
				} else {
					window.location.replace(response.headers.location);

				}
			}).catch(err => {
				dispatch(loginError(JSON.stringify(err.response)));
			});
	};
}

export function validateToken(token) {
	return dispatch => {
		return axios.post(mainUrl + "auth/tokenValidate", null, {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
		}).then(response => {
			if (response.status === 200) {
				localStorage.setItem('id_token', token);
				localStorage.setItem('userId', response.data.id);
				localStorage.setItem('accountId', response.data.accountId);
				localStorage.setItem('isAdmin', "" + (response.data.isAdmin || false));
				localStorage.setItem('isSuperman', "" +  (response.data.isSuperman || false));
				localStorage.setItem('isEventCreator', "" + (response.data.isEventCreator || false));
				localStorage.setItem('accessCode', response.data.accessCode);
				localStorage.setItem('userFirstName', response.data.firstName);
				localStorage.setItem('userLastName', response.data.lastName);
				dispatch(updateLogin(response.data.id, response.data.isAdmin, response.data.isSuperman, response.data.accountId, response.data.accessCode, response.data.userFirstName, response.data.userLastName, response.data.isEventCreator));
				dispatch(tokenValid(token));
			} else {
				dispatch(tokenInvalid());
			}
		}).catch(err => {
			if (err.response) {
				dispatch(loginError(JSON.stringify(err.response.data)));
				dispatch(tokenInvalid());
			} else {
				dispatch(loginError(JSON.stringify(err)));
				dispatch(tokenInvalid());
			}

		});
	};
}
// Logs the user out
export function logoutUser() {
	return dispatch => {
		dispatch(requestLogout());
		// localStorage.clear();
		localStorage.removeItem('id_token');
		localStorage.removeItem('access_token');
		localStorage.removeItem('accountId');
		localStorage.removeItem('userId');
		localStorage.removeItem('isAdmin');
		localStorage.removeItem('isSuperman');
		localStorage.removeItem('isEventCreator');
		localStorage.removeItem('userFirstName');
		localStorage.removeItem('userLastName');
		dispatch(receiveLogout());
	};
}



// WEBPACK FOOTER //
// ./src/Store/Actions/LoginActions.js